
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import Cta from '@/partials/Cta'
 
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Build & Launch Your Partner Portal, Pages and Directory",
  "date": "2021-05-23"
};
const slug = 'partnerplatform';
const tableOfContents = [{
  "title": "Building a defensible moat among the competition is hard",
  "slug": "building-a-defensible-moat-among-the-competition-is-hard",
  "children": []
}, {
  "title": "Purpose of Partner Ecosystem",
  "slug": "purpose-of-partner-ecosystem",
  "children": []
}, {
  "title": "Use Cases how you can use Tradly - Partner Portal",
  "slug": "use-cases-how-you-can-use-tradly-partner-portal",
  "children": [{
    "title": "1. App Store",
    "slug": "1-app-store",
    "children": []
  }, {
    "title": "2. Service Directory",
    "slug": "2-service-directory",
    "children": []
  }, {
    "title": "3. Experts Directory",
    "slug": "3-experts-directory",
    "children": []
  }, {
    "title": "4. Reseller Directory",
    "slug": "4-reseller-directory",
    "children": []
  }, {
    "title": "5. Developer Marketplace / Portal",
    "slug": "5-developer-marketplace-portal",
    "children": []
  }, {
    "title": "6. Hardware Partner Networls",
    "slug": "6-hardware-partner-networls",
    "children": []
  }]
}, {
  "title": "Example of Partner Portals and App Marketplaces",
  "slug": "example-of-partner-portals-and-app-marketplaces",
  "children": [{
    "title": "Shopify",
    "slug": "shopify",
    "children": []
  }, {
    "title": "Github Marketplace",
    "slug": "github-marketplace",
    "children": []
  }]
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p>{`Looking to build your partner portal with directory and partner specific pages for your SaaS business?
Tradly provides a headless API and Open source templates to launch your partner directory and growing an ecosystem around it. `}</p>
    <_Heading level={2} id={"building-a-defensible-moat-among-the-competition-is-hard"} nextElement={{
      "type": "paragraph"
    }}>Building a defensible moat among the competition is hard</_Heading>
    <p>{`With so much competition in every side of the business, it’s hard to build a sustainable price. `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Price wars`}</li>
      <li parentName="ul">{`Features to features matrix comparison`}</li>
      <li parentName="ul">{`Brand Popularity & Distribution `}</li>
    </ul>
    <p>{`It’s hard to compete in the ever growing SaaS wars, so how do we handle the sitautions? Build partner alliance, ecosystem, service providers network, etc around the brand can help your brand sustain. Until you take care of the partners, the partners will take care of your clients. Simple as that. `}</p>
    <p>{`It’s easy to launch a portal using Tradly but growing the partner ecosystem is a time take process, it evolves and gradually grows. If you have already a network of partners working on silo, then it must be easy to start and launch with a bang! `}</p>
    <div class="relative">
    <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/PartnerPortal.png" alt="Shopify Appstore" />
    </div>
    <div class="relative">
    <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/Appstorepage.png" alt="Shopify Appstore" />
    </div>
    <p>{`FIND LIVE DEMO: `}<a parentName="p" {...{
        "href": "https://saaspartners.tradly.co/"
      }}>{`https://saaspartners.tradly.co/`}</a></p>
    <_Heading level={2} id={"purpose-of-partner-ecosystem"} nextElement={{
      "type": "paragraph"
    }}>Purpose of Partner Ecosystem</_Heading>
    <p>{`There must be a purpose behind why you are launching this and strategic goals. And this must be aligned with management, partnership team, channel managers and developer team. `}</p>
    <p>{`You could evolve your partner portal based on your business needs and the signals you get from this mini launches. `}</p>
    <table className="text-lg">
	<tbody>
		<tr>
			<td><strong> PHASE1 - Information </strong></td>
			<td><strong>PHASE2 - Community </strong></td>
			<td><strong>PHASE3 - Commerce </strong></td>
		</tr>
		<tr>
			<td> Expert directory, Information based directory, Portal and Pages</td>
			<td> Ratings, Reviews, Partner Messaging</td>
			<td> Transactions, Subscription, Installing App </td>
		</tr>
        		<tr>
			<td> Zapier Expert Directory</td>
			<td> Wordpress.org ecosystem with review system </td>
			<td>Github and Atlassian Marketplace with Commerce</td>
		</tr>
		
	</tbody>
    </table>
    <_Heading level={2} id={"use-cases-how-you-can-use-tradly-partner-portal"} nextElement={{
      "type": "heading",
      "depth": 3
    }}>Use Cases how you can use Tradly - Partner Portal</_Heading>
    <_Heading level={3} id={"1-app-store"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>1. App Store</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Partners who are building applications, software, add-ins, plugins, extensions on top of your product. `}</li>
      <li parentName="ul">{`Example: Shopify Store, Hubspot, Intercom store, The big 5 appstores, etc. `}</li>
      <li parentName="ul">{`Driven by: Product Managers, Product Marketers & Developer Relations`}</li>
    </ul>
    <_Heading level={3} id={"2-service-directory"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>2. Service Directory</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Deliver value added, outsourced IT services, integrations support, custom feature building services.`}</li>
      <li parentName="ul">{`Example: SAP, Oracle Partners  `}</li>
    </ul>
    <_Heading level={3} id={"3-experts-directory"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": true
    }}>3. Experts Directory</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li">{`Experts are pure collection of experts profile, their skill set and type of services they provide. `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Mailchimp expert directory `}<a parentName="p" {...{
            "href": "https://mailchimp.com/experts/"
          }}>{`https://mailchimp.com/experts/`}</a>{` `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Shopify Experts directory (Developers, designers and freelancers). `}<a parentName="p" {...{
            "href": "https://experts.shopify.com/"
          }}>{`https://experts.shopify.com/`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Zapier Experts Directory (`}<a parentName="p" {...{
            "href": "https://zapier.com/experts"
          }}>{`https://zapier.com/experts`}</a>{`)`}</p>
      </li>
    </ul>
    <_Heading level={3} id={"4-reseller-directory"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>4. Reseller Directory</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Resell or distribute your software or hardware products.or build a channel through recruitment, development and enablement to reach customers at scale.`}</li>
      <li parentName="ul">{`Also called as System integrator “SI”`}</li>
    </ul>
    <_Heading level={3} id={"5-developer-marketplace-portal"} nextElement={{
      "type": "paragraph"
    }}>5. Developer Marketplace / Portal</_Heading>
    <p>{`Developer portals need more technical integrations. However this technical part where a users need to INSTALL app process happens mostly in the core product via webhook. So a directory can be served as merchandising solution`}</p>
    <p>{`Example: Github Developer Marketplace
`}<a parentName="p" {...{
        "href": "https://github.com/marketplace/imgbot"
      }}>{`https://github.com/marketplace/imgbot`}</a></p>
    <_Heading level={3} id={"6-hardware-partner-networls"} nextElement={{
      "type": "paragraph"
    }}>6. Hardware Partner Networls</_Heading>
    <p>{`Companies that you recommend or approve who has certain standard in their hardware product that support your business. `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Manufacture devices like POS, sensorts, trackers, etc `}</li>
    </ul>
    <Cta mdxType="Cta" />
    <_Heading level={2} id={"example-of-partner-portals-and-app-marketplaces"} nextElement={{
      "type": "heading",
      "depth": 3
    }}>Example of Partner Portals and App Marketplaces</_Heading>
    <_Heading level={3} id={"shopify"} nextElement={{
      "type": "jsx"
    }}>Shopify</_Heading>
    <div class="relative">
    <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/Snip20210522_165-1024x565.png" alt="Shopify Appstore" />
    </div>
    <div class="relative">
    <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/Snip20210522_166-1024x661.png" alt="Shopify Appstore" />
    </div>
    <div class="relative">
    <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/Snip20210522_167-1024x549.png" alt="Shopify Appstore" />
    </div>
    <div class="relative">
    <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/Snip20210522_168-1024x495.png" alt="Shopify Appstore" />
    </div>
    <_Heading level={3} id={"github-marketplace"} nextElement={{
      "type": "jsx"
    }}>Github Marketplace</_Heading>
    <div class="relative">
    <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/githubmarketplace1.png" alt="Intercom App Store" />
    </div>
    <div class="relative">
    <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/githubmarketplace2.png" alt="Intercom App Store" />
    </div>
    <div class="relative">
    <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/githubmarketplace3.png" alt="Intercom App Store" />
    </div>
    <div class="relative">
    <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/Snip20210522_169-1024x698.png" alt="Intercom App Store" />
    </div>
    <div class="relative">
    <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/Snip20210522_171.png" alt="Slack Appstore" />
    </div>
    <Cta mdxType="Cta" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
